import React from 'react';

export const IconTrendingUp = ({
  size = 12,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.85245 9.06875L1.1163 8.3356L4.72745 4.72744L6.62745 6.62744L9.11005 4.15435H7.68044V3.11685H10.8837V6.31713H9.8462V4.8875L6.62745 8.09375L4.72745 6.19375L1.85245 9.06875Z"
        fill="currentColor"
      />
    </svg>
  );
};
